import * as React from 'react'
import { Outlet } from 'react-router-dom'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import CollectionsBootstrap from '../lib/CollectionsBootstrap'

const RootPage = () => {
  React.useEffect(() => {
    track(trackingEvents.security.goToSecuritySettings)
  }, [])

  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
